import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { ASSETS, BRAND, NAV_LINKS, whatsappHref } from "../../data/content";

export const Nav = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  return (
    <>
      <motion.nav
        data-testid="main-nav"
        className="fixed top-0 left-0 right-0 z-[100] bg-[#fbf8f0]/95 backdrop-blur-xl border-b border-[#ddb128]/30 shadow-[0_1px_0_rgba(7,65,43,0.05)]"
      >
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 h-[76px] flex items-center justify-between gap-6">
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center shrink-0"
            aria-label="The Brook at Khanna's Farm — home"
          >
            <img
              src={ASSETS.monogramGreen}
              alt="The Brook at Khanna's Farm"
              className="h-12 w-auto object-contain"
            />
          </a>

          <div className="hidden xl:flex items-center gap-4 flex-1 justify-center">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className="font-body text-[10.5px] tracking-[0.12em] uppercase whitespace-nowrap text-[#07412b] relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#ddb128] after:transition-all after:duration-300 hover:after:w-full hover:text-[#c56928]"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <a
              href={whatsappHref()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-reserve-btn"
              className="inline-flex items-center rounded-full bg-[#ddb128] text-[#07412b] px-5 sm:px-6 py-2.5 text-[12px] tracking-[0.16em] uppercase font-semibold border border-[#ddb128] hover:bg-[#f0c545] hover:border-[#f0c545] transition-colors duration-300 shadow-[0_6px_18px_-6px_rgba(221,177,40,0.7)]"
            >
              Reserve
            </a>
            <button
              onClick={() => setOpen(true)}
              data-testid="mobile-menu-open"
              className="xl:hidden p-2 text-[#07412b]"
              aria-label="Open menu"
            >
              <Menu size={26} />
            </button>
          </div>
        </div>
      </motion.nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[200] bg-[#07412b] flex flex-col"
            data-testid="mobile-menu"
          >
            <div className="h-[76px] flex items-center justify-between px-5">
              <img
                src={ASSETS.headerLogoWhite}
                alt="The Brook"
                className="h-11 w-auto object-contain"
              />
              <button
                onClick={() => setOpen(false)}
                data-testid="mobile-menu-close"
                className="text-[#f7f3e9] p-2"
                aria-label="Close menu"
              >
                <X size={28} />
              </button>
            </div>
            <div className="flex-1 flex flex-col justify-center gap-1 px-8 overflow-y-auto py-6">
              {NAV_LINKS.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-link-${l.href.slice(1)}`}
                  initial={{ opacity: 0, x: -24 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.08 + i * 0.06 }}
                  className="font-display text-3xl sm:text-4xl text-[#f7f3e9] py-3 border-b border-[#ddb128]/20"
                >
                  {l.label}
                </motion.a>
              ))}
            </div>
            <div className="p-8">
              <a
                href={whatsappHref()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-reserve-btn"
                className="block text-center rounded-full bg-[#ddb128] text-[#07412b] px-6 py-4 text-sm tracking-[0.16em] uppercase font-semibold"
              >
                Reserve on WhatsApp
              </a>
              <p className="text-center text-[#b2dbaf] text-xs mt-4 tracking-wide">
                {BRAND.phoneDisplay}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
